<bricks-card>
  <div class="card-custom">
    <div class="card-custom__item">
      <h3>
        <span>Erzeugung</span>
      </h3>
      <div class="input-tooltip-row">
        <bricks-input
          appFormatView
          [focusOutFormatter]="ViewFormatterService.numberToLocaleStringFormatter()"
          [label]="'Gesamte installierte Leistung'"
          [placeholder]="'Wird berechnet'"
          [width]="'fill'"
          [isReadonly]="true"
          [formControl]="formGroup.controls.totalInstalledCapacity"
          name="totalInstalledCapacity">
          <span text-suffix>kW(p)</span>
        </bricks-input>
      </div>
      <div class="input-tooltip-row">
        <bricks-input
          [showResetOption]="true"
          appDigitsOnly
          [allowComma]="false"
          appFormatView
          [width]="'fill'"
          [focusInFormatter]="$any(ViewFormatterService.numberToStringFormatter)"
          [focusOutFormatter]="ViewFormatterService.integerToStringFormatter()"
          [changeFormatter]="ViewFormatterService.stringToNumberFormatter"
          [label]="'Geplante Erzeugung pro Jahr'"
          [placeholder]="'Wird berechnet'"
          [type]="'text'"
          [isRequired]="true"
          [formControl]="formGroup.controls.plannedProductionPerYear"
          name="plannedProductionPerYear">
          <span text-suffix>kWh</span>
          @if (getPlannedProductionPerYearError(formGroup.controls.plannedProductionPerYear)) {
            <bricks-error
              >{{ getPlannedProductionPerYearError(formGroup.controls.plannedProductionPerYear) }}
            </bricks-error>
          }
        </bricks-input>
        <app-tooltip
          text="Die geplante Erzeugung ist eine Hochrechnung auf Basis der installierten Leistung. Für Solaranlagen nehmen wir 1030 und für Windkraftanlagen 1890 Volllaststunden jährlich an. Diese können je nach Standort abweichen. Sie können diesen Wert gemäß Ihrer spezifischen Anlage anpassen." />
      </div>
      @if (enableSmallDV) {
        <div class="input-tooltip-row">
          <bricks-input
            [label]="'Geplanter Eigenverbrauch pro Jahr'"
            [showResetOption]="true"
            [placeholder]="'z. B. 20'"
            [isRequired]="true"
            [formControl]="formGroup.controls.ownConsumptionPercent"
            [width]="'fill'"
            appDigitsOnly
            width="fill"
            [type]="'number'"
            name="ownConsumptionPercent">
            <span text-suffix>%</span>
            @if (getOwnConsumptionPercentError(formGroup.controls.ownConsumptionPercent)) {
              <bricks-error>{{ getOwnConsumptionPercentError(formGroup.controls.ownConsumptionPercent) }}</bricks-error>
            }
          </bricks-input>
          <app-tooltip
            text="Der Eigenverbrauch bezeichnet den Anteil des erzeugten Stroms, der direkt vor Ort vom Anlagenbetreiber selbst genutzt wird – also nicht ins öffentliche Stromnetz eingespeist wird. Der Eigenverbrauch von Trafos oder etwaiger Beleuchtung ist hier nicht zu berücksichtigen." />
        </div>
        <div class="input-tooltip-row">
          <bricks-input
            [label]="'Geplanter Eigenverbrauch pro Jahr'"
            [showResetOption]="true"
            [placeholder]="'z. B. 57000'"
            [isRequired]="true"
            [formControl]="formGroup.controls.ownConsumptionKw"
            [width]="'fill'"
            appDigitsOnly
            [allowComma]="false"
            appFormatView
            [focusInFormatter]="$any(ViewFormatterService.numberToStringFormatter)"
            [focusOutFormatter]="ViewFormatterService.integerToStringFormatter()"
            [changeFormatter]="ViewFormatterService.stringToNumberFormatter"
            width="fill"
            [type]="'text'"
            name="ownConsumptionKw">
            <span text-suffix>kWh</span>
            @if (getOwnConsumptionKwError(formGroup.controls.ownConsumptionKw)) {
              <bricks-error>{{ getOwnConsumptionKwError(formGroup.controls.ownConsumptionKw) }}</bricks-error>
            }
          </bricks-input>
          <app-tooltip
            text="Der Eigenverbrauch bezeichnet den Anteil des erzeugten Stroms, der direkt vor Ort vom Anlagenbetreiber selbst genutzt wird – also nicht ins öffentliche Stromnetz eingespeist wird. Der Eigenverbrauch von Trafos oder etwaiger Beleuchtung ist hier nicht zu berücksichtigen." />
        </div>
        <div class="info-panel">
          <div class="info-panel__header">
            <span class="info-panel__title"> Geplante Einspeisung pro Jahr </span>
            <span class="info-panel__description">(Erzeugung - Eigenverbrauch)</span>
          </div>
          <div class="info-panel__value">
            <span id="feedInPerYear"
              >{{ integerToStringFormatter(formGroup.controls.feedInPerYear.value ?? '') }} kWh</span
            >
          </div>
        </div>
      }
    </div>
  </div>
</bricks-card>

<bricks-card>
  <div class="card-custom">
    <div class="card-custom__item">
      <h3>
        <span>
          Ist ein Batterie-Speicher am Standort vorhanden oder geplant?
          <app-required-asterisk />
        </span>
      </h3>
      @for (option of batteryStorageOptions; track option.value) {
        <div [formGroup]="formGroup">
          <input
            [id]="`batteryStorageStatus-${option.value}`"
            class="bricks-input"
            type="radio"
            [value]="option.value"
            name="batteryStorageStatus"
            [formControl]="formGroup.controls.batteryStorageStatus"
            [class.error]="
              formGroup.controls.batteryStorageStatus.hasError('required') &&
              formGroup.controls.batteryStorageStatus.touched
            " />
          <label [for]="`batteryStorageStatus-${option.value}`" class="density">
            {{ option.label }}
          </label>
        </div>
      }
    </div>
  </div>
</bricks-card>
@if (useBatteryStorage()) {
  <bricks-card>
    <div class="card-custom">
      <div class="card-custom__item">
        <h3>
          <span>
            Wie nutzen Sie den Batteriespeicher (aktuell oder zukünftig)
            <app-required-asterisk />
          </span>
          <bricks-icon
            color="primary"
            height="24px"
            width="24px"
            class="tooltip-overlay__icon"
            (click)="openBatteryUsageHint()">
            bricks-help
          </bricks-icon>
        </h3>
        @for (option of batteryUsageOptions; track option) {
          <div>
            <input
              [id]="`batteryStorageUsage-${option.value}`"
              class="bricks-input"
              type="checkbox"
              (change)="onBatteryUsageChange(option.value, $any($event.target).checked)"
              [class.error]="
                formGroup.controls.batteryStorageUsages.hasError('required') &&
                formGroup.controls.batteryStorageUsages.touched
              " />
            <label [for]="`batteryStorageUsage-${option.value}`" class="density">
              {{ option.label }}
            </label>
          </div>
        }
      </div>
    </div>
  </bricks-card>
}
